import { useActiveSection } from '@/hooks/useActiveSection';

interface AnchorNavItem {
  id: string;
  label: string;
}

export function AnchorNav({ items }: { items: AnchorNavItem[] }) {
  const active = useActiveSection(items.map((it) => it.id));

  return (
    <>
    <div
      style={{
        position: 'sticky',
        top: 64,
        zIndex: 20,
        background:
          'linear-gradient(180deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.02) 100%)',
        backdropFilter: 'blur(22px) saturate(160%)',
        WebkitBackdropFilter: 'blur(22px) saturate(160%)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.08)',
        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.06)',
        padding: '12px 0',
      }}
    >
      <div className="container">
        <div
          className="anchor-nav-inner"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            overflowX: 'auto',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          <span
            className="text-mono"
            style={{
              color: 'var(--ink-muted)',
              fontSize: 12,
              marginRight: 8,
              whiteSpace: 'nowrap',
            }}
          >
            ON THIS PAGE /
          </span>
          {items.map((it) => (
            <a
              key={it.id}
              href={`#${it.id}`}
              onClick={(e) => {
                e.preventDefault();
                const el = document.getElementById(it.id);
                if (el)
                  window.scrollTo({
                    top: el.offsetTop - 80,
                    behavior: 'smooth',
                  });
              }}
              style={{
                fontSize: 13,
                fontWeight: 500,
                padding: '6px 12px',
                borderRadius: 6,
                color:
                  active === it.id
                    ? 'var(--ink-on-accent)'
                    : 'var(--ink-secondary)',
                background:
                  active === it.id
                    ? 'var(--accent)'
                    : 'linear-gradient(135deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.02) 100%)',
                border:
                  active === it.id
                    ? '1px solid transparent'
                    : '1px solid rgba(255,255,255,0.08)',
                backdropFilter: active === it.id ? 'none' : 'blur(10px)',
                WebkitBackdropFilter: active === it.id ? 'none' : 'blur(10px)',
                whiteSpace: 'nowrap',
                transition:
                  'background 160ms var(--ease-in-out), color 160ms var(--ease-in-out), border-color 160ms var(--ease-in-out)',
                textDecoration: 'none',
              }}
            >
              {it.label}
            </a>
          ))}
        </div>
      </div>
    </div>
    <style>{`
      .anchor-nav-inner::-webkit-scrollbar { display: none; }
      @media (max-width: 880px) {
        .anchor-nav-inner {
          -webkit-mask-image: linear-gradient(to right, black 80%, transparent 100%);
          mask-image: linear-gradient(to right, black 80%, transparent 100%);
        }
      }
    `}</style>
    </>
  );
}
